import { ModalTypes, TargetTypes } from "../TargetTypeManagement";
import { ComplianceManager } from "./ComplianceManager";
import { DeviceTypeManager } from "./DeviceTypeManager";
import { LocationManager } from "./LocationManager";
import { SectorsManager } from "./SectorsManager";
import { MsbManager } from "./MsbManager";
import { GroupManager } from "./GroupManager";

export class ModalManager {

    constructor(targetType, setModalProps, setModalType, setShowModal, setPopup, targetTypesList) {
        let manager;

        switch (targetType) {
            case TargetTypes.COMPLIANCE:
                manager = new ComplianceManager(setModalProps, setModalType, setShowModal, 
                    setPopup, targetTypesList.compliance.filter(el => el.base !== true))
                break;
            case TargetTypes.DEVICE_TYPE:
                manager = new DeviceTypeManager(setModalProps, setModalType, setShowModal, 
                    setPopup, targetTypesList.deviceTypes.filter(el => el.base !== true))
                break;
            case TargetTypes.LOCATION:
                manager = new LocationManager(setModalProps, setModalType, setShowModal, 
                    setPopup, targetTypesList.locations.filter(el => el.base !== true))
                break;
            case TargetTypes.SECTORS:
                manager = new SectorsManager(setModalProps, setModalType, setShowModal, 
                    setPopup, targetTypesList.sectors.filter(el => el.base !== true))
                break;
            case TargetTypes.MSB:
                manager = new MsbManager(setModalProps, setModalType, setShowModal, 
                    setPopup, targetTypesList.msbList.filter(el => el.baseMsb !== true))
                break;
            case TargetTypes.GROUP:
                manager = new GroupManager(setModalProps, setModalType, setShowModal, 
                    setPopup, targetTypesList.groups.filter(el => el.base !== true))
                break;
            default:
                break;
        }

        this.manager = manager;
    }

    showModal = (modalType) => {

        const manager = this.manager;

        switch (modalType) {
            case ModalTypes.CREATE:
                manager.showAddModal();
                break;
            case ModalTypes.EDIT:
                manager.showEditModal();
                break;
            case ModalTypes.REMOVE:
                manager.showRemoveModal();
                break;
            default:
                break;
        }

    }


}
